module.exports = __webpack_public_path__ + "static/media/adn-ending.9f47174b.mp3";